export const CREATE_TAG = 'CREATE_TAG';
export const LIST_TAGS = 'LIST_TAGS';
export const EDIT_TAGS = 'EDIT_TAGS';
export const DELETE_TAGS = 'DELETE_TAGS'
